import { render, staticRenderFns } from "./MatchSettingsList.vue?vue&type=template&id=408300d3"
import script from "./MatchSettingsList.vue?vue&type=script&lang=js"
export * from "./MatchSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports